import React from 'react';
import parse from 'html-react-parser';
import { MarkdownRenderer } from './MarkdownRender';

const Text = ({ message }) => {
  const rawMarkdown = message?.text

  // const handleNewUserMessage = (newMessage) => {
  //   // console.trace();
  //   // Replace &nbsp; with a regular space
  //   let cleanedMessage = newMessage.replace(/&nbsp;/g, ' ');
  //   cleanedMessage = cleanedMessage.replace(/\n/g, ' <br />');

  //   const urlRegex = /(https?:\/\/[^\s]+)/g;
  //   if (urlRegex.test(parse(cleanedMessage))) {
  //     // Split the message into parts: text and URLs
  //     const parts = cleanedMessage.split(urlRegex);
  //     // Iterate over parts to add separate messages
  //     const messageElements = parts.map((part, index) => {
  //       if (urlRegex.test(part)) {
  //         // This part is a URL
  //         return (
  //           <a key={index} href={part} target="_blank" rel="noopener noreferrer">
  //             {parse(part)}
  //           </a>
  //         );
  //       } else if (part.trim().length > 0) {
  //         // This part is regular text
  //         return <span key={index}>{parse(part)}</span>;
  //       } else {
  //         return null; // Handle edge cases if any
  //       }
  //     });
  //     return messageElements;
  //   } else {
  //     // No URLs found, add the message as regular text
      
  //     return (cleanedMessage && <p style={{ margin: '0px', whiteSpace: 'pre-wrap' }}>{parse(cleanedMessage)}</p>);
  //   }
  // };

  return (
    <div className='rcw-message-content text-msg-container'>
      <MarkdownRenderer content={ rawMarkdown } />
      {/* {message && message.text ? handleNewUserMessage(message.text) : ''} */}
    </div>
  );
};

export default Text;
